<template>
  <div class="giftcardpurchase">
    <v-sheet elevation="2" class="pa-6">
      <v-row>
        <v-col class="text-center">
          <h2 v-if="configName">{{configName}}</h2>
        </v-col>
      </v-row>
      <v-divider class="mt-3 mb-5" />
      <v-row>
        <v-col>
          <p>Who do you want to receive the email for this gift certificate?</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            outlined
            label="Email Address"
            v-model="email"
            hide-details
            :rules="emailRules"
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <v-btn :disabled="!canSubmit" depressed x-large color="primary" @click="search">Submit</v-btn>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <a style="color: #0068ff; text-decoration: underline;" @click="skip">Send email directly to me instead.</a>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'GiftCardGifteeSearch',

  data() {
    return {
      submitPending: false,
      email: null,
      emailRules: [ 
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ]
    }
  },

  computed: {
    canSubmit() {
      if (this.submitPending) return false
      return this.email && this.email.length > 5
    },
    selectedConfig() {
      return this.$store.state.giftCardConfigs.data.find((o) => o.id === this.$store.state.directToGiftCardId)
    },
    configName() {
      return this.selectedConfig?.name
    }
  },

  methods: {
    async search() {
      this.submitPending = true
      await this.$store.dispatch('checkGifteeExists', this.email)
        .then((res) => {
          console.log(res)
          this.$store.commit('setGifteeId', res.gifteeId)
          this.$store.commit('setGifteeEmail', this.email)
          this.submitPending = false

          // Clear the gift card coupon
          this.$store.state.coupon = null

          this.$router.push({ name: 'CartView', query: { mtek_id: this.$store.state.mtek_id } })
        })
        .catch((err) => {
          console.log(err)
          this.submitPending = false
        })
    },
    skip() {
      this.$store.commit('setGifteeEmail', this.$store.state.user.email)
      this.$router.push({ name: 'CartView', query: { mtek_id: this.$store.state.mtek_id } })
    }
  },

  beforeMount() {
    // If disallowGifteeSelection is true, skip the giftee search step
    if (this.selectedConfig?.disallowGifteeSelection) {
      this.$store.commit('setGifteeId', null)
      this.$store.commit('setGifteeEmail', null)
      this.$store.commit('setGifteeEmail', this.$store.state.user.email)
      this.$router.push({ name: 'CartView', query: { mtek_id: this.$store.state.mtek_id } })
    }
  }
}
</script>

<style lang="scss">

</style>